<div id="product" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        @if (!isOrganizer) {
          <button class="mr-0 mr-sm-16" mat-icon-button [routerLink]="'/pages/organization'">
            <mat-icon>arrow_back</mat-icon>
          </button>
        }

        <div class="product-image mr-8 mr-sm-16" *fuseIfOnDom
          [@animate]="{value:'*',params:{delay:'50ms',scale:'0.2'}}">
          @if (organization && img) {
            <img [src]="getImage(img)">
          }
          @if (!organization || !organization.logo) {
            <img [src]="'assets/images/organization.svg'">
          }
        </div>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
          @if (organization) {
            <div class="h2">
              {{organization.name}}
            </div>
          }
          <div class="subtitle secondary-text">
            <span>{{'organization.organization_detail' | translate}}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->


      <div>

        @if (!isOrganizer) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="showAdmins()">
            <span>{{'organization.show_admin' | translate}}</span>
          </button>
        }

        @if (!isOrganizer) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="addAdmin()">
            <span>{{'organization.add_admin' | translate}}</span>
          </button>
        }

        <button mat-raised-button
          class="save-product-button mat-white-bg mt-16 mt-sm-0"
          [disabled]="formGroup && formGroup.invalid"
          (click)="updateOrganization(true)">
          <span>{{'main.update' | translate}}</span>
        </button>

        @if (!isOrganizer) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="deleteOrganization()">
            <span>{{'main.delete' | translate}}</span>
          </button>
        }

        <button mat-raised-button
          class="save-product-button mat-white-bg mt-16 mt-sm-0"
          (click)="openWizzard()">
          <span>{{'main.wizzard' | translate}}</span>
        </button>
      </div>

    </div>
    <!-- / HEADER -->

    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">
        <div class="content-block">

          <cropper [avatar]="logo" [page]="'org-detail'" (sendImg)="setImg($event)"></cropper>
          @if (organization) {
            <div style="margin: 10px">
              <mat-accordion>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{'main.dynamicData' | translate}}
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <mat-card appearance="outlined" style="margin: 10px;" class="privacy">
                    <mat-card-header>
                      <mat-card-title style="  text-decoration: underline;">
                        {{'main.dynamicData' | translate}}
                      </mat-card-title>
                      <i style="font-size: 35px; right: 40px;position: absolute; cursor: pointer" (click)="newType()"
                        class="material-icons">
                        add_box
                      </i>
                      <i style="font-size: 35px; right: 80px;position: absolute; cursor: pointer"
                        (click)="changePrivacy()" class="material-icons">
                        playlist_add
                      </i>
                    </mat-card-header>
                    <mat-list role="list">
                      <h2 mat-subheader>Active</h2>
                      @for (item of systemDynamicOrgData; track item; let i = $index) {
                        @if (item.active) {
                          <mat-list-item role="listitem">
                            <div class="listitem-top">
                              <mat-icon style="cursor: pointer" (click)="editType(item, false)" mat-list-icon>edit</mat-icon>
                              <mat-slide-toggle mat-line [checked]="true" (change)="changeStatus(item)">{{item.name}}
                              </mat-slide-toggle>
                            </div>

                            @if (item.type !=='system') {
                              <p mat-line>{{item.text}}</p>
                            }
                          </mat-list-item>
                        }
                      }
                    </mat-list>
                    <mat-list role="list">
                      <h2 mat-subheader>No Active</h2>
                      @for (item of systemDynamicData; track item; let i = $index) {
                        @if (item.type !=='system') {
                          <mat-list-item role="listitem">
                            <mat-icon style="cursor: pointer" (click)="editType(item, true)" mat-list-icon>edit</mat-icon>
                            <mat-slide-toggle mat-line [checked]="false" (change)="activeData($event, i)">{{item.name}}
                            </mat-slide-toggle>
                            @if (item.type !=='system') {
                              <p mat-line>{{item.text}}</p>
                            }
                          </mat-list-item>
                        }
                      }
                      @for (item of systemDynamicOrgData; track item; let i = $index) {
                        @if (!item.active) {
                          <mat-list-item role="listitem">
                            <mat-icon style="cursor: pointer" (click)="editType(item, false)" mat-list-icon>edit</mat-icon>
                            <mat-slide-toggle mat-line [checked]="false" (change)="changeStatus(item)">{{item.name}}
                            </mat-slide-toggle>
                            @if (item.type !=='system') {
                              <p mat-line>{{item.text}}</p>
                            }
                          </mat-list-item>
                        }
                      }
                    </mat-list>
                  </mat-card>
                </mat-expansion-panel>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{'organization.rates' | translate}}
                    </mat-panel-title>
                    <mat-panel-description>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <mat-grid-list cols="2" rowHeight="55px">
                    <mat-grid-tile>
                      @if (!edit) {
                        <button mat-raised-button  (click)="edit = !edit;editRates();"> <mat-icon style="font-size: 2rem; margin: 0 auto;">settings</mat-icon></button>
                      }
                      @if (edit) {
                        <button mat-raised-button  (click)="edit = !edit; saveRates()"> <mat-icon style="font-size: 2rem; margin: 0 auto;">save</mat-icon></button>
                      }
                    </mat-grid-tile>
                    <mat-grid-tile><b>{{'organization.rates' | translate}}</b></mat-grid-tile>
                    @for (item of adminTypes; track item) {
                      <mat-grid-tile><b>{{item.name}}</b></mat-grid-tile>
                      @if (adminRates && adminRates[item.id] && adminRates[item.id]['preparation']) {
                        <mat-grid-tile
                          >
                          @if (!edit) {
                            <span>
                              {{adminRates[item.id]['preparation']}}
                            </span>
                          }
                          @if (edit) {
                            <mat-form-field style="width: -webkit-fill-available;" >
                              <span matPrefix>CHF/EUR</span>
                              <input type="number" matInput [(ngModel)]="adminRates[item.id]['preparation']" (ngModelChange)="changeRates({type: 'preparation', id: item.id, value: $event})">
                              <mat-icon matSuffix>.-</mat-icon>
                            </mat-form-field>
                          }
                        </mat-grid-tile>
                      } @else {
                        <mat-grid-tile>
                          @if (!edit) {
                            <span>0</span>
                          }
                          @if (edit) {
                            <mat-form-field style="width: -webkit-fill-available;">
                              <span matPrefix>CHF/EUR</span>
                              <input type="number" matInput [(ngModel)]="newRates[item.id]['preparation']" (ngModelChange)="changeRates({type: 'preparation', id: item.id, value: $event})">
                              <mat-icon matSuffix>.-</mat-icon>
                            </mat-form-field>
                          }
                        </mat-grid-tile>
                      }
                    }
                  </mat-grid-list>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="generateUrl">
                <div class="url-title">{{'tag_event_page' | translate}}</div>
                <button mat-raised-button
                  class="save-product-button mat-white-bg mt-16 mt-sm-0"
                  (click)="copyCodeFunc()">
                  <span>{{'Copy_code' | translate}}</span>
                </button>
                <input id="copyEmbedUrl" value='<embed type="text/html" src="{{embedUrl}}" width="100%" height="100%">' readonly>
              </div>
              <div class="generateUrl">
                <div class="url-title">{{'home_page_org' | translate}}</div>
                <button mat-raised-button
                  class="save-product-button mat-white-bg mt-16 mt-sm-0"
                  (click)="copyUrlFunc()">
                  <span>{{'Copy_url' | translate}}</span>
                </button>
                <input id="copyUrl" value="{{copyUrl}}" readonly>
              </div>
              @if (copyRegUrl) {
                <div class="generateUrl">
                  <div class="url-title">{{'easy_reg' | translate}}</div>
                  <button mat-raised-button
                    class="save-product-button mat-white-bg mt-16 mt-sm-0"
                    (click)="copyRegUrlFunc()">
                    <span>{{'Copy_url' | translate}}</span>
                  </button>
                  <input id="copyRegUrl" value="{{copyRegUrl}}" readonly>
                  <div style="margin-top: 20px">
                    <button mat-raised-button
                      class="save-product-button mat-white-bg mt-16 mt-sm-0"
                      (click)="downloadQRcode()">
                      <span>{{'download_code' | translate}}</span>
                    </button>
                    <div #qrContainer class="qr-wrapper">
                      <ngx-qrcode-styling [config]="config" [data]="copyRegUrl"></ngx-qrcode-styling>
                    </div>
                  </div>
                </div>
              }
            </div>
          }

        </div>
        <div class="content-block">
          <form [formGroup]="formGroup" class="canton-form">
            <mat-form-field class="width-100">
              <mat-label>{{ 'organization.name' | translate }}</mat-label>
              <input formControlName="name" matInput required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-50">
              <mat-label>{{ 'organization.country' | translate }}</mat-label>
              <mat-select formControlName="countryId" required>
                @for (country of countries; track country.id) {
                  <mat-option [value]="country.id">
                    {{country.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-50">
              <mat-label>{{ 'organization.canton' | translate }}</mat-label>
              <mat-select formControlName="cityId" required multiple>
                @for (city of cities; track city) {
                  <mat-option [value]="city.id">
                    {{city.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="width-100">
              <mat-label>{{ 'organization.city' | translate }}</mat-label>
              <input formControlName="cityLocation" matInput required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-100">
              <mat-label>{{ 'user.lang' | translate }}</mat-label>
              <mat-select formControlName="lang" required>
                @for (lang of languages; track lang) {
                  <mat-option [value]="lang.value">
                    {{lang.label}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="width-100">
              <mat-label>{{ 'organization.organizationType' | translate }}</mat-label>
              <mat-select formControlName="organizationTypeId" required>
                @for (type of types; track type) {
                  <mat-option [value]="type.id">
                    {{type.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="width-50">
              <mat-label>{{ 'organization.address' | translate }}</mat-label>
              <input formControlName="address" matInput>
            </mat-form-field>
            <mat-form-field class="width-50">
              <mat-label>{{ 'organization.postcode' | translate }}</mat-label>
              <input formControlName="postcode" matInput>
            </mat-form-field>
            <mat-form-field class="width-100">
              <mat-label>{{ 'organization.website' | translate }}</mat-label>
              <input formControlName="website" matInput>
            </mat-form-field>
            <mat-form-field class="width-100">
              <mat-label>{{ 'user.phone' | translate }}</mat-label>
              <input formControlName="phone" matInput appPhoneMask>
            </mat-form-field>
            @if (formGroup.get('whatsapp')?.enabled) {
              <mat-checkbox class="width-100" formControlName="whatsapp">{{'WhatsApp' | translate}}</mat-checkbox>
            }
            @if (formGroup.get('isTest')?.enabled) {
              <mat-checkbox class="width-100" formControlName="isTest">{{'isTest' | translate}}</mat-checkbox>
            }
            @if (formGroup.get('allowCompetency')?.enabled) {
              <mat-checkbox class="width-100" formControlName="allowCompetency">{{'competency.competency' | translate}}</mat-checkbox>
            }
            @if (formGroup.get('allowTimeAndBudget')?.enabled) {
              <mat-checkbox class="width-100"
                            formControlName="allowTimeAndBudget">{{ 'organization.allowTimeAndBudget' | translate }}
              </mat-checkbox>
            }
            <mat-checkbox class="width-100" formControlName="allowGuestEvent">{{ 'organization.allowGuestEvent' | translate }}</mat-checkbox>
          </form>
        </div>


      </div>
      <!-- / CONTENT -->

    </div>

  </div>
  <!-- / CENTER -->
</div>



